import React, { FC } from 'react';
import { Box, Heading, SimpleGrid, Stack, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { countriesAddedByPlan, countriesForPlan, displayName, sortByDisplayName, unclassifiedCountries } from '@/data/plans';

const Column: FC<{ title: string; intro?: string; countries: string[] }> = ({ title, intro, countries }) => (
  <Stack gap='2'>
    <Heading size='sm'>{title}</Heading>
    {intro && <Text fontSize='xs' color='fg.muted'>{intro}</Text>}
    {sortByDisplayName(countries).map((iso3) => (
      <Text key={iso3} fontSize='sm'>{displayName(iso3)}</Text>
    ))}
  </Stack>
);

const CountriesByPlan: FC = () => {
  const { t } = useTranslation('landing');
  return (
    <Box id='countries-by-plan' mt='12'>
      <Heading size='md' mb='6' textAlign='center'>{t('homepage.pricing.countriesTitle')}</Heading>
      <SimpleGrid columns={{ base: 1, md: 3 }} gap='8'>
        <Column title='Free & Lite' countries={countriesForPlan('Lite')} />
        <Column title='Plus' intro={t('homepage.pricing.plusAddsAll')} countries={countriesAddedByPlan('Plus')} />
        <Column title='Enterprise' intro={t('homepage.pricing.enterpriseAddsAll')} countries={countriesAddedByPlan('Enterprise')} />
      </SimpleGrid>
      <Text fontSize='sm' color='fg.muted' mt='8'>
        {t('homepage.pricing.alsoLive')} {sortByDisplayName(unclassifiedCountries()).map((iso3) => displayName(iso3)).join(', ')}
      </Text>
    </Box>
  );
};

export default CountriesByPlan;
